<script lang="ts">
  import { getContextClient, queryStore } from "@urql/svelte"
  import { autouncleBrandTheme } from "lib/constants"
  import { getContext } from "svelte"
  import { ParsedWidget } from "website_script/lib/Parsers"
  import { GET_PRICE_RATINGS_FOR_WIDGET } from "website_script/operations/getPriceRatingsForWidget"
  import type { Settings } from "website_script/types/settings"
  import PriceRatingWidget from "../components/PriceRatingWidget.svelte"
  import InlineWidget from "./InlineWidget.svelte"
  import { trackFunction } from "website_script/lib/tracking"

  export let urls: string[]
  export let widgets: ParsedWidget[]

  const { id } = getContext<Settings>("settings")

  const client = getContextClient()
  const priceRatings = queryStore({
    client,
    query: GET_PRICE_RATINGS_FOR_WIDGET,
    variables: {
      customerId: id,
      urls,
    },
  })

  $: priceRatingsMap = new Map(
    ($priceRatings.data?.priceRatings ?? []).map((rating) => [
      rating.customerCarUrl,
      rating,
    ])
  )

  $: priceRatingWidgets = widgets.map((widget) => ({
    ...widget,
    priceRating: widget.elData.carUrl
      ? priceRatingsMap.get(widget.elData.carUrl) ?? null
      : null,
  }))

  function trackRatingsDisplayed(
    ratings: NonNullable<typeof $priceRatings.data>["priceRatings"] | undefined
  ) {
    if (!ratings?.length) return

    trackFunction({
      entity: "price_rating_widget",
      action: "displayed",
      type: "displayed_cta",
      details: `${ratings.length} widgets`,
    })
  }

  $: trackRatingsDisplayed($priceRatings.data?.priceRatings)
</script>

{#if priceRatingWidgets.length}
  {#each priceRatingWidgets as widget, i (widget.elTarget || i)}
    {#if widget.priceRating?.car}
      <InlineWidget target={widget.elTarget} theme={autouncleBrandTheme}>
        <PriceRatingWidget car={widget.priceRating?.car} />
      </InlineWidget>
    {/if}
  {/each}
{/if}
